import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import { WA_GREEN, formatPhone } from "@/utils/whatsapp";
import { useUserWhatsApp } from "./useUserWhatsApp";
import { WhatsAppQRModal } from "./WhatsAppQRModal";

export function TopbarWhatsApp() {
    const { t } = useTranslation();
    const { status } = useUserWhatsApp(true, 60000);
    const [open, setOpen] = useState(false);
    const on = !!status?.connected;
    return (
        <>
            <button type="button" data-testid="topbar-whatsapp-btn" onClick={() => setOpen(true)}
                title={on && status?.phone ? `${t("uwa.status.connected")}: ${formatPhone(status.phone)}` : t("uwa.topbar.connect")}
                className="relative inline-flex items-center gap-2 rounded-md px-2.5 text-sm border transition-colors hover:bg-[var(--selected-bg)]"
                style={{ minHeight: 40, minWidth: 44, color: "var(--text)", background: "var(--input)", borderColor: on ? WA_GREEN : "var(--border)" }}>
                <span className="relative inline-flex">
                    <MessageCircle size={16} style={{ color: WA_GREEN }} />
                    <span data-testid="topbar-whatsapp-dot" className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full ring-2 ring-[var(--input)]" style={{ background: on ? WA_GREEN : "var(--text-muted)" }} />
                </span>
                <span className="hidden lg:inline text-xs font-medium tabular-nums" data-testid="topbar-whatsapp-label">
                    {on && status?.phone ? formatPhone(status.phone) : t("uwa.topbar.connect")}
                </span>
            </button>
            <WhatsAppQRModal open={open} onClose={() => setOpen(false)} />
        </>
    );
}
